export default __webpack_public_path__ + "ee369f1.png";